import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { experienceData } from "../data/ExperienceData";

const Experience = () => {
  return (
    <div className='experience'>
      <Container fluid>
        <Row>
          <Col lg='5' className='p-0'>
            <div className='left-content'>
              <img src={experienceData.image} alt='myimage' />
            </div>
          </Col>
          <Col lg='7'>
            <div className='right-content'>
              <h1>{experienceData.title}</h1>
            </div>
            {experienceData.data.map((data, i) => {
              return (
                <div key={i} className='exp-content'>
                  <div className='exp-head'>
                    <h3>
                      {data.company}
                      <small>{`, ${data.city}`}</small>
                    </h3>
                  </div>
                  <p>{data.jobtitle}</p>
                  <small>{data.startYear + " - " + data.endYear}</small>
                </div>
              );
            })}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Experience;
